module.exports = __webpack_public_path__ + "static/media/5-min.1495d266.png";